module.exports = {"id":"211110","name":"Paulo Dybala","rating":"89","photo":"./data/images/photos/2/211110.png","club":{"name":"Juventus","logo":"./data/images/clubs/Juventus.png"},"positions":["MOC","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PauloDybala0.json
// module id = 3401
// module chunks = 0